export default __webpack_public_path__ + "locales/el-GR/Profile.json?hash=a931df18fd607bcdaf4bb0444a995e74";